// @flow
import { Box, Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { motion } from 'framer-motion';
import { useInView, InView } from 'react-intersection-observer';
import chunk from 'lodash.chunk';
import * as React from 'react';

import { ProductCard } from './product-card';
import Line from './shared/line';

type Props = {
  products: any,
  title: string,
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.motorX.gray,
    padding: theme.spacing(10, 0),
  },
}));

export default function ProductListing({ products = [], title }: Props) {
  const classes = useStyles();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: false,
  });
  const partitions = chunk(products, 4);
  const [index, setIndex] = React.useState(0);

  const variants = {
    visible: { opacity: 1, scale: 1, y: 0 },
    hidden: {
      opacity: 0,
      scale: 1,
      y: 100,
    },
  };

  return (
    <InView threshold={0.02} triggerOnce>
      {({ inView: mainInView, ref: mainRef }) => (
        <motion.div
          animate={mainInView ? 'visible' : 'hidden'}
          transition={{ duration: 1, ease: 'easeOut' }}
          ref={mainRef}
          className={classes.root}
        >
          <Container maxWidth="lg">
            <Grid
              component={motion.div}
              container
              spacing={6}
              animate={inView ? 'visible' : 'hidden'}
              ref={ref}
              variants={variants}
              transition={{ duration: 0.7, ease: 'easeOut' }}
            >
              {partitions.length > 1 && (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      component="div"
                      alignItems="center"
                      alignContent="center"
                      mb={5}
                    >
                      <div>
                        {partitions.map((products, idx) => (
                          <Line
                            key={products[0].id}
                            active={index === idx}
                            onClick={() => setIndex(idx)}
                          />
                        ))}
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              )}

              <Grid item xs={12}>
                <Typography
                  style={{ fontWeight: 700 }}
                  align="center"
                  variant="h4"
                  gutterBottom
                >
                  {title}
                </Typography>
              </Grid>
              {partitions[index].map((product, index) => (
                <ProductCard
                  product={product}
                  key={product.id}
                  eager={index === 0}
                />
              ))}
            </Grid>
          </Container>
        </motion.div>
      )}
    </InView>
  );
}
